document.addEventListener('click', function (e) {
  const card = e.target.closest('.tr-price-card');
  if (!card) return;

  const qtyInput = document.querySelector('.quantity__input');
  if (!qtyInput) return;

  const minQty = parseInt(card.dataset.minQty, 10);
  if (!minQty || isNaN(minQty)) return;

  const inputMin = parseInt(qtyInput.getAttribute('min') || 1, 10);
  const inputMax = qtyInput.hasAttribute('max')
    ? parseInt(qtyInput.getAttribute('max'), 10)
    : null;

  let finalQty = Math.max(minQty, inputMin);
  if (inputMax !== null) {
    finalQty = Math.min(finalQty, inputMax);
  }

  // Update input value
  qtyInput.value = finalQty;

  
  // Active state UI
  document
    .querySelectorAll('.tr-price-card')
    .forEach(el => el.classList.remove('tr-price-card-active'));

  card.classList.add('tr-price-card-active');
});
